import React from "react";
import { createPortal } from "react-dom";
import { ClockIcon, XIcon } from "@heroicons/react/outline";
import { useIdleSession } from "../../helpers/sessionTimeout";

const SessionTimeout = () => {
  const { open, countdown, stayPending, stayMessage, onStay, onDismiss } = useIdleSession();

  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 flex items-end sm:items-center justify-center p-4" style={{ zIndex: 10000 }} role="presentation">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" aria-hidden="true" />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="session-timeout-title"
        data-testid="session-timeout-dialog"
        className="relative w-full max-w-md rounded-xl border border-gray-100 bg-white p-6 shadow-2xl"
      >
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Close"
          className="absolute top-3 right-3 rounded-full p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-700"
        >
          <XIcon className="h-5 w-5" />
        </button>
        <div className="flex items-start gap-3 pr-6">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white">
            <ClockIcon className="h-6 w-6" />
          </span>
          <div>
            <h2 id="session-timeout-title" className="text-xl font-semibold text-gray-900">
              Session expiring
            </h2>
            <p className="mt-1 text-sm text-gray-600">
              You have been inactive. For security, you will be signed out when the timer ends.
            </p>
          </div>
        </div>

        <p
          className="mt-5 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 bg-clip-text text-center text-4xl font-semibold tracking-wide text-transparent"
          data-testid="session-timeout-countdown"
          aria-live="polite"
        >
          {countdown}
        </p>

        {stayMessage ? <p className="mt-3 text-center text-sm text-rose-600">{stayMessage}</p> : null}

        <div className="mt-6 flex justify-center">
          <button
            type="button"
            onClick={onStay}
            disabled={stayPending}
            data-testid="session-timeout-stay"
            className={`w-full rounded-md px-4 py-2 text-sm font-medium text-white sm:w-auto ${
              stayPending
                ? "cursor-not-allowed bg-gray-400"
                : "bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 hover:from-blue-600 hover:via-purple-600 hover:to-pink-600"
            }`}
          >
            {stayPending ? "Checking session..." : "Stay Logged In"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default SessionTimeout;
